// removed by extract-text-webpack-plugin
module.exports = {"betaBeta":"betaBadge-module__betaBeta___1Ovr9","isSmall":"betaBadge-module__isSmall___2qWnd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/betaBadge.module.scss
// module id = 309
// module chunks = 1